import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const TooltipOverlay = () => {
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* TOOLTIP OVERLAYS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Tooltip Overlays</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Top Tooltip</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-24 flex items-center justify-center">
              <div className="relative">
                <button onMouseEnter={() => setShow1(true)} onMouseLeave={() => setShow1(false)} className="px-3 py-1 bg-slate-700 text-slate-300 rounded text-sm">Hover me</button>
                {show1 && <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 bg-slate-900 text-slate-100 text-xs px-2 py-1 rounded border border-slate-600 whitespace-nowrap">Hello tooltip!</div>}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const [show, setShow] = useState(false);

return (
  <div className="relative inline-block">
    <button onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      Hover
    </button>
    {show && (
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-slate-900 text-xs px-2 py-1 rounded whitespace-nowrap">
        Tooltip text
      </div>
    )}
  </div>
);`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Bottom Tooltip</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-24 flex items-center justify-center">
              <div className="relative">
                <button className="px-3 py-1 bg-slate-700 text-slate-300 rounded text-sm" onMouseEnter={() => setShow2(true)} onMouseLeave={() => setShow2(false)}>Hover here</button>
                {show2 && <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-amber-900 border border-amber-600 text-amber-200 text-xs px-2 py-1 rounded whitespace-nowrap">Info: something helpful</div>}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">
  <button onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
    Hover
  </button>
  {show && (
    <div className="absolute top-full mt-2 bg-amber-900 rounded p-2">
      Tooltip content
    </div>
  )}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Left Tooltip</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-24 flex items-center justify-end pr-6">
              <div className="relative">
                <button className="px-3 py-1 bg-slate-700 rounded">?</button>
                <div className="absolute right-full mr-2 top-1/2 transform -translate-y-1/2 bg-slate-900 text-slate-100 text-xs px-2 py-1 rounded border border-slate-600">Left info</div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">
  <button>?</button>
  <div className="absolute right-full mr-2 bg-slate-900 rounded p-2 text-xs">
    Help text
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Right Tooltip</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-24 flex items-center justify-start pl-6">
              <div className="relative">
                <button className="px-3 py-1 bg-slate-700 rounded">i</button>
                <div className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 bg-amber-900 text-amber-200 text-xs px-2 py-1 rounded border border-amber-600">Right info</div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">
  <button>i</button>
  <div className="absolute left-full ml-2 bg-amber-900 rounded p-2">
    Info text
  </div>
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED TOOLTIPS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Rich Tooltip</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-28 flex items-center justify-center">
              <div className="relative">
                <button className="px-3 py-1 bg-blue-600 text-white rounded text-sm">Learn more</button>
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-slate-900 border border-slate-600 rounded p-2 w-40 text-xs">
                  <p className="text-slate-200 font-bold">Feature Info</p>
                  <p className="text-slate-400 text-xs mt-1">This is a detailed tooltip with multiple lines</p>
                </div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="absolute bottom-full bg-slate-900 rounded p-3 w-48 border border-slate-600">
  <p className="font-bold text-slate-200">Title</p>
  <p className="text-slate-400 text-sm mt-1">Detailed description goes here</p>
  <button className="mt-2 text-xs text-blue-400">Learn more</button>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Arrow Tooltip</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 h-28 flex items-center justify-center">
              <div className="relative">
                <button className="px-3 py-1 bg-slate-700 rounded">Hover</button>
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 bg-slate-900 text-slate-100 text-xs px-2 py-1 rounded border border-slate-600">
                  <div>Tooltip with arrow</div>
                  <div className="absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 bg-slate-900 border-b border-r border-slate-600" style={{transform: 'rotate(45deg)'}}></div>
                </div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="relative">
  <div className="absolute bg-slate-900 rounded p-2 before:content before:absolute before:top-full">
    Tooltip
    <div className="absolute top-full left-1/2 -translate-x-1/2 w-2 h-2 bg-slate-900 rotate-45" />
  </div>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TooltipOverlay;


